/* global DELICIOUS_WEB_ROOT */
const _ = require( 'lodash' );
const redux = require( 'redux' );
const morphdom = require( 'morphdom' );

class Item {
	constructor( item ) {
		_.extend( this, item );
	}

	render(){
		let displayTitle = this.title;
		if( this.type.indexOf( 'music' !== -1 ) ) {
			displayTitle = `${this.title} - ${this.artist}`;
		}
		return `
		<div class="item">
			<img class="item-cover-image" src="${this.getCoverImageUrl()}" title="${this.title}"/>
			<div class="item-title">${displayTitle}</div>
		</div>`;
	}

	getCoverImageUrl(){
		return `${DELICIOUS_WEB_ROOT}/covers/${this.coverImage}`.replace( /\/\//g, '/' );
	}

	getSortKey(){
		// For music, return artist
		if( this.type.indexOf( 'music' ) !== -1 ) {
			return this.artist.toLowerCase();
		}
		// For anything other than music or books, return the title
		if( this.type.indexOf( 'books' ) === -1 ) {
			return this.title.toLowerCase();
		}
		// For books, return the primary author's last name
		let author = this.artist.toLowerCase();
		// Quick hack to sort by primary author's last name
		// TODO add to item's properties
		let indexOfAnd = Math.max(
			author.indexOf( ' and ' ),
			author.indexOf( ' & ' ),
			author.indexOf( ', ' )
		);
		if( indexOfAnd !== -1 ) {
			author = author.substr( 0, indexOfAnd );
		}
		author = author.split( ' ' );
		return author[ author.length - 1 ];
	}
}

class Shelf {
	constructor( shelf ) {
		_.extend( this, shelf );
		this.items = _.chain( shelf.items )
		.map( item=>{
			return new Item( item );
		} )
		.sortBy( item=>item.getSortKey() )
		.value();
	}

	render() {
		return `
		<div class="shelf">
			<div class="shelf-title">${this.displayName}</div>
			<div class="shelf-content">
				${_.map( this.items, item=>item.render() ).join( '\n' )}
			</div>
		</div>`;
	}
}

class StateRoot {
	constructor( initialState ) {
		this.store = redux.createStore( state=>state, initialState );
	}

	render() {
		return ``;
	}

	renderTo( elt ) {
		// TODO assert that len is 0
		const doRender = ()=>{
			let contents = this.render().trim();
			morphdom( elt, contents );
		};
		doRender();
		return this.subscribe( doRender );
	}

	subscribe( onChange ){
		let previousState = this.store.getState();
		let unsubscribe = this.store.subscribe( ()=>{
			let newState = this.store.getState();
			if( previousState === newState ) {
				return;
			}
			previousState = newState;
			onChange();
		} );
		return unsubscribe;
	}

	getState(){
		return this.store.getState();
	}
}

class Library extends StateRoot {
	render() {
		const shelves = _.map( this.getState().shelves, shelf=>new Shelf( shelf ) );
		return `
		<div id="js-app">
			${_.map( shelves, shelf=>shelf.render() ).join( '\n' )}
		</div>`;
	}
}

module.exports = Library;



//////////////////
// WEBPACK FOOTER
// ./client/library.js
// module id = 13
// module chunks = 0